import React from 'react';
import ContentLayout from 'components/ContentLayout/SmartLayout';
import Move from 'components/Sales/Smart/MoveMerge/Move';
import { getWarehouseCodeFromCache } from 'utils';
import { LS_DEFAULT_WAREHOUSE_KEY } from 'constants/config';

export default function SmartMove(): JSX.Element {
  return (
    <ContentLayout 
    titleKey="titles.moveIndividual" value={getWarehouseCodeFromCache(Number(localStorage.getItem(LS_DEFAULT_WAREHOUSE_KEY)))}
    //  title={`Move individual product(W#: ${getWarehouseCodeFromCache(Number(localStorage.getItem(LS_DEFAULT_WAREHOUSE_KEY)))})`}
     >
      <Move />
    </ContentLayout>
  );
}
